/* @flow */
import {
  SET_MODAL_OPTIONS,
  ADD_INDICATOR_TAG,
  REMOVE_INDICATOR_TAG,
  ADD_INDICATOR_TAGS_BULK,
  FETCH_ENCLAVE_TAGS
} from './action-types.js';

/* NOTE: All tags are fetched during app initialization */

export const setModalOpen = (open: boolean): Object => ({
  type: SET_MODAL_OPTIONS,
  payload: open
});

type AddTag = {
  name: string,
  enclaveGuid: string,
  type: string,
  value: string,
};

export const addIndicatorTag = (payload: AddTag): Object => ({
  type: ADD_INDICATOR_TAG,
  payload,
});

export const addIndicatorTagsBulk = (payload: any): Object => ({
  type: ADD_INDICATOR_TAGS_BULK,
  payload,
});


export const deleteIndicatorTag = (guid: string, type: string, value: string): Object => ({
  type: REMOVE_INDICATOR_TAG,
  payload: { guid, type, value }
});


export const fetchEnclaveTags = () => ({
  type: FETCH_ENCLAVE_TAGS,
});


// WEBPACK FOOTER //
// ./src/app/modules/tags/actions.js